<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        گزارش نقطه جوش انبار فروشگاه بر حسب سال
      </q-banner>
    </q-card-section>
    <q-card-section class="text-center">
      <q-chip size="lg" v-for="(item, index) in range(1399,1403, 1)" :label="item" square color="indigo" text-color="white" clickable
              @click="loadReport(item)" :key="index"/>
    </q-card-section>
  </q-card>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: "ShopBoilingPoint",
  components: {},
  data() {
    return {
      Years: []
    }
  },
  methods: {
    ...mapActions({}),
    range(start, end, step) {
      return Array.from(Array.from(Array(Math.ceil((end - start) / step)).keys()), x => start + x * step);
    },
    async loadReport(args) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مدیر فروش/نقطه جوش انبار?rs:Format=PDF&Year=${args}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
  }
}
</script>

<style scoped>

</style>